// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';

/**
 * Keywords to highlight in abstracts (case-insensitive, must be at start of line)
 */
const ABSTRACT_KEYWORDS = ['PURPOSE', 'METHODS', 'METHODOLOGY', 'RESULTS', 'CONCLUSION', 'CONCLUSIONS', 'BACKGROUND', 'OBJECTIVE', 'OBJECTIVES', 'PUBLIC INTEREST SUMMARY'];

/**
 * Process abstract text to highlight section keywords
 * Keywords at the start of lines are bolded for better readability
 * 
 * @param abstract - Raw abstract text
 * @returns React fragments with highlighted keywords
 */
export function processAbstractText(abstract: string): React.ReactNode {
  const abstractText = abstract.replace(/^NA:\s*/i, '');
  
  // Split by lines and process each line
  const lines = abstractText.split('\n');
  const processedLines = lines.map((line: string, index: number) => {
    // Check if line starts with a keyword (case-insensitive)
    const keywordMatch = ABSTRACT_KEYWORDS.find(keyword => {
      const regex = new RegExp(`^${keyword}\\s*:`, 'i');
      return regex.test(line.trim());
    });
    
    if (keywordMatch) {
      // Find the actual keyword in the line (preserve original case)
      const match = line.match(new RegExp(`^\\s*(${keywordMatch})\\s*:`, 'i'));
      if (match) {
        const keyword = match[1];
        const restOfLine = line.substring(match[0].length);
        return (
          <React.Fragment key={index}>
            <strong style={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.95)' }}>
              {keyword}:
            </strong>
            {restOfLine}
            {index < lines.length - 1 && '\n'}
          </React.Fragment>
        );
      }
    }
    
    // Return line as-is with newline if not last
    return (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && '\n'}
      </React.Fragment>
    );
  });
  
  return processedLines;
}

